import React, { useEffect, useRef, useState } from "react";
import PleaseLoginPrompt from "./PleaseLoginPrompt";
import { endpoints } from "../utils/Constants";
import useMiniSite from "../hooks/useMiniSite.js";
import Tick from "../assets/icons/tick.svg";

const FollowButton = ({ artistNodeId, callback }) => {
  // Embedded pages don't support login, which following requires. Strip the button and
  // all follow logic (status fetch, follow/unfollow, login prompt). Use the hostname-based
  // check so it hides whether the embedded URL is loaded directly or hosted in an iframe
  // (the frame-based self!==top is false on a direct load). Constant for the page
  // lifetime, so this early return is hook-safe.
  const { isEmbedded } = useMiniSite();
  if (isEmbedded) return null;

  const loginRef = useRef();
  const [following, setFollowing] = useState(false);

  const isAuthenticated = $("#__HD_RequestVerificationToken").length > 0;

  useEffect(() => {
    if (isAuthenticated) fetchData();
  }, []);

  const fetchData = () => {
    let url = endpoints.event.followArtist(artistNodeId);

    fetch(url, {
      method: "GET",
    })
      .then((res) => res.json())
      .then(setFollowing)
      .catch((error) => {
        console.error(`Can't fetch artist!`, error);
      });
  };

  const followArtist = (unfollow) => {
    let url = endpoints.event.followArtist(artistNodeId);

    fetch(url, {
      method: unfollow ? "DELETE" : "POST",
    })
      .then(() => {
        setFollowing(unfollow ? false : true);
        if (callback)
          callback((followers) => (unfollow ? followers - 1 : followers + 1));
      })
      .catch((error) => {
        console.error(`Can't fetch artist!`, error);
      });
  };

  const handleClick = () => {
    if (!isAuthenticated) loginRef.current?.handleOpen();
    else if (following) followArtist(true);
    else followArtist();
  };

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          height: 32,
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px 12px",
          borderRadius: 24,
          border: "1px solid #EDF1F6",
          background: "#FFFFFF",
          color: "#2F1A6B",
          fontFamily: "pf_highway_sans_pro_mediumRg",
          textAlign: "center",
          fontSize: 14,
          fontWeight: 600,
          lineHeight: "16px",
          cursor: "pointer",
          gap: 8,
        }}
      >
        {following && <Tick />}
        {following
          ? artistpage_resources.Following
          : artistpage_resources.Follow}
      </div>

      <PleaseLoginPrompt
        prompt={artistpage_resources.SignInPrompt}
        desc={artistpage_resources.StayUpdated}
        icon={"/site/images/icons/music-notes.png"}
        ref={loginRef}
      />
    </>
  );
};

export default FollowButton;
